{
  "SET_NEW_PASSWORD": {
    "TITLE": "设置新密码",
    "PASSWORD": {
      "LABEL": "密码",
      "PLACEHOLDER": "密码",
      "ERROR": "密码太短了."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "请重新输入一次密码",
      "PLACEHOLDER": "确认密码",
      "ERROR": "密码不匹配."
    },
    "API": {
      "SUCCESS_MESSAGE": "成功修改密码.",
      "ERROR_MESSAGE": "无法连接Woot服务器，请稍后再试"
    },
    "CAPTCHA": {
      "ERROR": "验证码过期。请重新获取"
    },
    "SUBMIT": "提交"
  }
}
